module.exports = __webpack_public_path__ + "img/team-management-background.fcadc0db.png";